import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const DomainNamespace_Organization = 'Organization';
export const DomainNamespace_OrganizationManager = 'organization-manager';
export const PermissionKey_OrganizationEdit = 'permission-key--organization-edit';
export const PermissionKey_OrganizationView = 'permission-key--organization-view';
export const PermissionKey_OrganizationDelete = 'permission-key--organization-delete';
export const OrganizationCollectionKeyMapper = {
    'edit': PermissionKey_OrganizationEdit,
    'delete': PermissionKey_OrganizationDelete,
    'view': PermissionKey_OrganizationView
};
export const OrganizationManagerKeysMapper = generateKeyNamesByAccessLevel(DomainNamespace_OrganizationManager, defaultUIAccessLevels);
export const Organization__QuaiMD_ID = '4c813b976331c152edbfd03e1b52d2e6';
export const Organization__MUSC_ID = '07934669e58a14f24a5496347c086fa6';
export const Organization__Mayo_ID = 'd85c0bf2590de04eef0a8af0b212c74b';
//# sourceMappingURL=consts.js.map